"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Title = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const title_styles_1 = __importDefault(require("./title.styles"));
const Title = ({ classes, left, right, type }) => (jsx_runtime_1.jsxs("div", Object.assign({ className: classes.titleContainer, "data-cy": "atomic-title" }, { children: [jsx_runtime_1.jsx("div", Object.assign({ type: type, className: classes.titleLeft }, { children: left }), void 0),
        jsx_runtime_1.jsx("div", Object.assign({ type: type, className: classes.titleRight }, { children: right }), void 0)] }), void 0));
exports.Title = Title;
exports.Title.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    left: prop_types_1.default.string,
    right: prop_types_1.default.string,
    type: prop_types_1.default.string
};
exports.Title.defaultProps = {
    left: 'Indigo',
    right: 'Trace',
    type: 'title'
};
exports.default = react_jss_1.default(title_styles_1.default)(exports.Title);
//# sourceMappingURL=index.js.map